export enum PillType {
    Draft = 'draft',
    Sent = 'sent',
    Success = 'success',
    Template = 'template',
    InProgress = 'in_progress',
    Warning = 'warning',
    Expired = 'expired',
    Default = 'default'
}

export enum PillSize {
    Small = 'sm',
    Medium = 'md'
}
